import RecordRTC from "recordrtc";
import io from "socket.io-client";
import config from "../config";
import { setRoomId, setParticipants } from "../store/actions";
import store from "../store/store";
import * as webRTCHandler from "./webRTCHandler";

let socket = null;

export const connectWithSocketIOServer = () => {
  socket = io(config.chatApiServer, {
    // ─── Reconnection config for Socket.IO client ──────────────────────────
    // socket.io-client has built-in exponential-backoff reconnection.
    // We enable it here with sensible defaults so L2 detection in
    // NetworkConnectionManager receives the reconnect_attempt / reconnect events.
    reconnection: true,
    reconnectionAttempts: Infinity,   // keep trying until our 30 s hard timeout fires
    reconnectionDelay: 1000,          // start at 1 s
    reconnectionDelayMax: 5000,       // cap at 5 s
    randomizationFactor: 0.3,
    timeout: 10000,
  });

  socket.on("connect", () => {
    console.log("Successfully connected with socket IO Server");
  });

  socket.on("room-id", (data) => {
    const { roomId } = data;
    store.dispatch(setRoomId(roomId));
  });

  socket.on("call-request", (data) => {
    const { roomId, toJid, toJidSocketId, fromUserName } = data;
    store.dispatch(setRoomId(roomId));
    console.log(
      `Incoming call request from ${fromUserName} to join room ${roomId}`
    );
    webRTCHandler.sendCallRequestAlert(fromUserName);
  });

  socket.on("room-update", (data) => {
    const { connectedUsers } = data;
    store.dispatch(setParticipants(connectedUsers));
  });

  socket.on("conn-prepare", (data) => {
    const { connUserSocketId } = data;
    webRTCHandler.prepareNewPeerConnection(connUserSocketId, false);
    socket.emit("conn-init", { connUserSocketId: connUserSocketId });
  });

  socket.on("conn-signal", (data) => {
    webRTCHandler.handleSignalingData(data);
  });

  socket.on("conn-init", (data) => {
    const { connUserSocketId } = data;
    webRTCHandler.prepareNewPeerConnection(connUserSocketId, true);
  });

  socket.on("user-disconnected", (data) => {
    webRTCHandler.removePeerConnection(data);
  });
};

export const loggedIn = (jid, name) => {
  const data = { jid, name };
  socket.emit("logged-in", data);
};

export const disconnect = () => {
  if (socket) {
    // Disable auto-reconnect before explicitly disconnecting so Socket.IO
    // doesn't immediately try to reconnect after a graceful leave.
    socket.io.opts.reconnection = false;
    socket.disconnect();
  }
};

export const isConnected = () => {
  return !(socket === null);
};

/**
 * Expose the raw socket so NetworkConnectionManager can attach its own listeners.
 */
export const getSocket = () => socket;

export const inviteToRoom = (
  identity,
  onlyAudio,
  fromJid = "",
  toJid = "",
  roomId = ""
) => {
  const data = {
    identity,
    onlyAudio,
    fromJid,
    toJid,
    roomId,
  };
  socket.emit("invite-to-room", data);
};

export const createNewRoom = (
  identity,
  onlyAudio,
  fromJid = "",
  toJid = "",
  cofferEmail = ""
) => {
  const data = {
    identity,
    onlyAudio,
    fromJid,
    toJid,
    cofferEmail,
  };
  socket.emit("create-new-room", data);
};

export const joinRoom = (identity, roomId, onlyAudio, fromJid, cofferEmail) => {
  const data = { roomId, identity, onlyAudio, fromJid, cofferEmail };
  socket.emit("join-room", data);
};

export const signalPeerData = (data) => {
  socket.emit("conn-signal", data);
};